import { VoltageSpeedDashboardSummary } from '../../voltage-with-speed.models';
import { formatEngineOnDuration } from '../kpis/kpis.utils';

export function buildEngineStates(summary: VoltageSpeedDashboardSummary | null) {
  const states = [
    { key: 'off', label: 'خاموش', seconds: summary?.EngineOffSeconds },
    { key: 'idle', label: 'درجا روشن', seconds: summary?.IdleSeconds },
    { key: 'moving', label: 'در حرکت', seconds: summary?.MovingSeconds }
  ].map(state => ({
    ...state,
    seconds: typeof state.seconds === 'number' && Number.isFinite(state.seconds) && state.seconds >= 0 ? state.seconds : null
  }));
  const total = states.every(state => state.seconds != null)
    ? states.reduce((sum, state) => sum + state.seconds!, 0) : 0;
  return states.map(state => ({
    ...state,
    duration: formatEngineOnDuration(state.seconds),
    percent: total > 0 && state.seconds != null ? state.seconds / total * 100 : null
  }));
}

export function getEngineVoltageDifference(summary: VoltageSpeedDashboardSummary | null): number | null {
  const on = summary?.AvgEngineOnVoltage;
  const off = summary?.AvgEngineOffVoltage;
  return typeof on === 'number' && Number.isFinite(on) && on >= 0
    && typeof off === 'number' && Number.isFinite(off) && off >= 0 ? on - off : null;
}
